// extracted by mini-css-extract-plugin
export default {"modalFooter":"ModalFooterContent_modalFooter__4Hn8S","notes":"ModalFooterContent_notes__12419","noteHeader":"ModalFooterContent_noteHeader__B1ynL"};